import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC, useCallback } from 'react'

import { ISalesFunnelCard } from '@user/store/salesFunnelSummary/typings'
import { SalesFunnelCard } from '../SalesFunnelCard/SalesFunnelCard'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSetOppSoldServicesStatusFilter } from '../SalesFunnelSummary/useSetOppSoldServicesStatusFilter'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { useNavigate } from 'react-router-dom'

const getStyles = (theme: Theme) => ({
  root: {
    maxWidth: '1299px',
    margin: 'auto',
    padding: theme.spacing(2),
    '@media (min-width: 1200px)': {
      padding: theme.spacing(0),
    },
  },

  title: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '18px',
  },
})

interface Props {
  funnelCards: ISalesFunnelCard[]
  handleClose: () => void
}

export const SalesFunnelDetails: FC<Props> = (props) => {
  const { funnelCards, handleClose } = props

  const [setFilter] = useSetOppSoldServicesStatusFilter()
  const navigate = useNavigate()
  const handleManageClick = useCallback(
    (status: SOLD_SERVICE_STATUS) => {
      setFilter(status)
      navigate('/opportunities')
    },
    [navigate, setFilter],
  )

  const styles = getStyles(useTheme())
  return (
    <Box pt={2} sx={styles.root}>
      <Box mb={2}>
        <Typography sx={styles.title}>Sales Funnel Details</Typography>
      </Box>
      {funnelCards.map((f, i) => (
        <SalesFunnelCard
          funnel={f}
          handleClose={handleClose}
          handleManageClick={handleManageClick}
          key={i}
        />
      ))}
    </Box>
  )
}

SalesFunnelDetails.displayName = 'SalesFunnelDetails'
